import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarCtaContainer = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <View pointerEvents="box-none" style={styles.container}>
      {children}
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const NAVBAR_CTA_MIN_WIDTH = 100;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    minWidth: NAVBAR_CTA_MIN_WIDTH,
  },
});
